import PanelFooter from './component';

export default PanelFooter;
